export default "__VITE_ASSET__BV2LL_Gv__"